import * as React from "react"
import * as Tooltip from "react-popover";

interface PopoverProps extends Tooltip.PopoverProps {}


class Popover extends React.Component<PopoverProps> {
    render() {
        return <Tooltip {...this.props} />;
    }
}

export default Popover;